export default __webpack_public_path__ + "static/media/headphones.5ae136cc.svg";